import {
  ClientDocumentRequestModel,
  IAddClientDocumentRequest,
  IClientDocumentRequestModel,
  IEmailClientDocumentRequest,
} from '@common/models';
import { ServiceHelper } from '@common/services/serviceHelper';
import { ServiceMethodOptions } from '@common/services/types';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class DocumentRequestService {
  private static baseUrl: string = '/api/documentrequest';

  public static tags = {
    addClientDocumentRequest: 'addClientDocumentRequest',
    emailclientdocument: 'emailclientdocument',
  };

  public static addClientDocumentRequest(
    request: IAddClientDocumentRequest,
    options?: ServiceMethodOptions,
  ) {
    return trackPromise(
      new Promise<IClientDocumentRequestModel>((resolve, reject) => {
        http(`${this.baseUrl}/clientdocumentrequest`)
          .post<IClientDocumentRequestModel>(request)
          .then((res) => resolve(new ClientDocumentRequestModel(res)))
          .catch((error) => reject(error));
      }),
      ServiceHelper.getTagForOptions(
        this.tags.addClientDocumentRequest,
        options,
      ),
    );
  }

  public static sendEmailclientdocument(
    request: IEmailClientDocumentRequest,
    options?: ServiceMethodOptions,
  ) {
    return trackPromise(
      new Promise<IEmailClientDocumentRequest>((resolve, reject) => {
        http(`${this.baseUrl}/emailclientdocument`)
          .post(request)
          .then(resolve)
          .catch((error) => reject(error));
      }),
      ServiceHelper.getTagForOptions(this.tags.emailclientdocument, options),
    );
  }
}
